interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  onClear: () => void;
}

export function SearchBar({ value, onChange, onSearch, onClear }: Readonly<SearchBarProps>) {
  return (
    <div className="relative w-full">
      <div className="flex items-center gap-2 h-[51px] w-full rounded-2xl border border-stroke-primary bg-bg-primary px-4">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="shrink-0 text-text-tertiary">
          <circle cx="9" cy="9" r="6" stroke="currentColor" strokeWidth="1.5" />
          <path d="M14 14l3.5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") onSearch();
          }}
          placeholder="Search..."
          className="flex-1 text-base font-semibold text-text-primary placeholder:text-text-tertiary outline-none bg-transparent"
        />
        {value && (
          <button
            onClick={onClear}
            className="text-text-tertiary hover:text-text-secondary shrink-0"
            aria-label="Clear search"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
